import React, { memo, useMemo } from 'react'
import classNames from 'classnames'
import { Button } from '@/components/ui'
import type { IButtonProps } from '@/components/ui/Button/interfaces'
import { useRegionSelect } from '@/components/ui/UserRegionSelect/UserRegionSelectPicker/hooks'
import { injectMessages } from '@/logic/translation/utils'
import messages from '../messages.json'
import type { IUserRegionSelectPickerProps } from '../types'
import './styles.scss'

injectMessages(messages)

const UserRegionSelectPickerDesktop: React.FC<IUserRegionSelectPickerProps> = props => {
  const { className, label, region, onClick, showSelector, genitiveCase } = props

  const { formatRegionName, selectorIcon } = useRegionSelect()

  const btnProps: IButtonProps = useMemo(
    () => ({
      isUnstyled: true,
      children: formatRegionName(region?.name, genitiveCase),
      ...(showSelector && selectorIcon),
      onClick,
    }),
    [formatRegionName, genitiveCase, onClick, region?.name, selectorIcon, showSelector],
  )

  return (
    <div className={classNames('userRegionSelectPickerDesktop', className)}>
      {label && <span className="userRegionSelectPickerDesktop__label">{label}</span>}
      <Button className="userRegionSelectPickerDesktop__button" {...btnProps} />
    </div>
  )
}

export default memo(UserRegionSelectPickerDesktop)
